module.exports = __webpack_public_path__ + "img/4.c1c40178.webp";